"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lilNounsSubgraphApiUri = void 0;
exports.lilNounsSubgraphApiUri = 'https://api.thegraph.com/subgraphs/name/lilnounsdao/lil-nouns-subgraph';
